import { Action } from '@ngrx/store';
import {MspRegion} from '../region.model';
import {Update} from '@ngrx/entity';

export enum RegionMspMemberActionTypes {
  GetMspMemberRegions = '[MspRegion] Get Msp Member Regions',
  GetMspMemberRegionSuccess = '[MspRegion] Get Msp Member Region Success',
  GetMspMemberRegionFail = '[MspRegion] Get Msp Member Region Fail',
}


export class GetMspMemberRegions implements Action {
  readonly type = RegionMspMemberActionTypes.GetMspMemberRegions;
  constructor(public payload: any = null ) {}
}

export class GetMspMemberRegionSuccess implements Action {
  readonly type = RegionMspMemberActionTypes.GetMspMemberRegionSuccess;
  constructor(public payload: any = null) {}
}

export class GetMspMemberRegionFail implements Action {
  readonly type = RegionMspMemberActionTypes.GetMspMemberRegionFail;
  constructor(public payload: any = null ) {}
}

export type MspMemberRegionActions = GetMspMemberRegions
  | GetMspMemberRegionSuccess
  | GetMspMemberRegionFail;
